// One highlighted next step (U3): the card's recommended action, which `Space` presses. The
// server marks at most one (the model's choice, else the first primary action); this reads it
// back defensively. With configured actions it never picks a runtime-injected local action
// (dismiss, snooze, archive); with NONE, Space archives the card (the injected default-cleanup,
// when its kind is archive), which runs on one press with Undo.
// A press goes through the same `press` as 1/2/3: a reversible action runs with Undo, an
// irreversible one (a send, a calendar write) only arms and needs its confirm press.
import type { CardAction } from "@shared/core";
import { recommendedIndex } from "@shared/startEasily";
import { archiveAction, isInjected } from "./actions";

export function recommendedAction(actions: readonly CardAction[]): CardAction | null {
  const configured = actions.filter((a) => !isInjected(a)).slice(0, 3);
  if (!configured.length) return archiveAction(actions);
  return configured[recommendedIndex(configured)] ?? null;
}
